module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login",
    attrs: {
      "id": "set_password"
    }
  }, [_c('div', {
    staticClass: "user-login-5"
  }, [_c('div', {
    staticClass: "row bs-reset"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 login-container bs-reset mt-login-5-bsfix"
  }, [(_vm.currentView === 'expired_token') ? _c('div', {
    staticClass: "login-content"
  }, [_c('h1', [_vm._v("This token is expired.")]), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.routeToLogin()
      }
    }
  }, [_vm._v("Return to Login")])]) : _vm._e(), _vm._v(" "), (_vm.currentView === 'set_password_form') ? _c('div', {
    staticClass: "login-content"
  }, [_c('h1', [_vm._v("Set UNOapp Password")]), _vm._v(" "), _c('p', {
    staticClass: "margin-10"
  }, [_vm._v("Enter your desired password in the fields below.")]), _vm._v(" "), _c('p', {
    staticClass: "margin-10"
  }, [_vm._v("Please note that you may only use a secure strengthened password.")]), _vm._v(" "), _c('p', {
    staticClass: "margin-10"
  }, [_vm._v("It is best to use at least 10 characters, and to avoid using dictionary words.")]), _vm._v(" "), _c('form', {
    staticClass: "login-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.setPassword($event)
      }
    }
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control form-control-solid placeholder-no-fix form-group",
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "Password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.strength.length) ? _c('div', {
    staticClass: "password-approval-blocks",
    class: {
      'very-weak': _vm.strength === 'Very Weak' || _vm.strength == 'Password must be 8 characters minimum', 'weak': _vm.strength === 'Weak', 'ok': _vm.strength === 'OK', 'strong': _vm.strength === 'Strong'
    }
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.strength.length) ? _c('div', {
    staticClass: "password-approval-text",
    class: {
      'very-weak': _vm.strength === 'Very Weak' || _vm.strength == 'Password must be 8 characters minimum', 'weak': _vm.strength === 'Weak', 'ok': _vm.strength === 'OK', 'strong': _vm.strength === 'Strong'
    }
  }, [_vm._v(_vm._s(_vm.strength))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control form-control-solid placeholder-no-fix form-group",
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "Confirm Password",
      "name": "confirm_password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.confirmPassword.length && !_vm.passwordsMatch) ? _c('div', {
    staticClass: "password-approval-text very-weak"
  }, [_vm._v("Passwords do not match")]) : _vm._e(), _vm._v(" "), (_vm.confirmPassword.length && _vm.passwordsMatch) ? _c('div', {
    staticClass: "password-approval-text strong"
  }, [_vm._v("Passwords match")]) : _vm._e()])]), _vm._v(" "), _vm._m(1)])]) : _vm._e(), _vm._v(" "), (_vm.currentView === 'password_success') ? _c('div', {
    staticClass: "login-content"
  }, [_c('h1', [_vm._v("Your password was set successfully!")]), _vm._v(" "), _c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        _vm.routeToLogin()
      }
    }
  }, [_vm._v("Login to UNOapp")])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 bs-reset mt-login-5-bsfix"
  }, [_c('div', {
    staticClass: "login-bg"
  }, [_c('img', {
    staticClass: "login-logo",
    attrs: {
      "src": require("../assets/img/app/logo.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('button', {
    staticClass: "btn green",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c58425a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SetPassword.vue
// module id = 420
// module chunks = 1